import {Account, Animals, Cameras, Collars, ConfigurationDevices, DataLoggers, DropOffs, ExternalSensors, TT4Sensors, Traps, Items} from './api'
import {Injectable} from '@angular/core'

@Injectable({providedIn: 'root'})
export class AllServices {
  constructor(
    public Account: Account,
    public Animals: Animals,
    public Cameras: Cameras,
    public Collars: Collars,
    public ConfigurationDevices: ConfigurationDevices,
    public DataLoggers: DataLoggers,
    public DropOffs: DropOffs,
    public ExternalSensors: ExternalSensors,
    public TT4Sensors: TT4Sensors,
    public Traps: Traps,
    public Items: Items,
  ) {}
}